export default __webpack_public_path__ + "static/media/settings.c20890b1.svg";